import React from 'react'
import Image from 'next/image'
import { Card, CardImage, CardBody, PublicationLogo, PressTitle, ReadMore, ReadMoreButton } from './styles'

export default function PressCard({ article, featured = false }) {
  if (!article) {
    return null
  }
  const { slug, title, publication_name, thumbnail, publication_logo } = article
  // The Strapi service resolves media URLs before they enter page props.
  const thumb = thumbnail?.url || ''
  const logo = publication_logo?.url || ''

  return (
    <Card featured={featured}>
      {thumb && (
        <CardImage featured={featured}>
          <Image src={thumb} alt={title || ''} fill style={{ objectFit: 'cover' }} />
        </CardImage>
      )}
      <CardBody featured={featured}>
        {logo && (
          <PublicationLogo>
            <Image src={logo} alt={publication_name || ''} fill />
          </PublicationLogo>
        )}
        <PressTitle featured={featured}>{title}</PressTitle>
        {featured ? (
          <ReadMoreButton href={`/press/${slug}`}>Read More</ReadMoreButton>
        ) : (
          <ReadMore href={`/press/${slug}`}>Read More</ReadMore>
        )}
      </CardBody>
    </Card>
  )
}
